import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../../../components/public/Footer';

export default function AvertissementRisques() {
  const [lang, setLang] = useState('En');

  useEffect(() => {
    const syncLang = () => {
      setLang((localStorage.getItem('januslang') || localStorage.getItem('janus_lang')) === 'Fr' ? 'Fr' : 'En');
    };
    syncLang();
    window.addEventListener('langchange', syncLang);
    window.addEventListener('januslangchanged', syncLang);
    return () => {
      window.removeEventListener('langchange', syncLang);
      window.removeEventListener('januslangchanged', syncLang);
    };
  }, []);

  const translations = {
    Fr: {
      metaTitle: "Avertissement sur les Risques | Janus Capital Strategy",
      metaDesc: "Avertissement sur les risques lies aux actifs numeriques et aux investissements proposes par Janus Capital Strategy.",
      title: "Avertissement sur les Risques",
      intro: "Les contenus diffuses sur ce site sont fournis a titre informatif et ne constituent ni un conseil juridique, ni un conseil fiscal, ni une sollicitation d'investissement personnalisee.",
      sections: [
        { h: "Actifs numeriques", p: "Les actifs numeriques, incluant Bitcoin et les autres cryptoactifs, comportent un risque de perte en capital, pouvant aller jusqu'a la perte totale du capital investi. Leur valeur peut connaitre une volatilite significative en raison de facteurs de marche, reglementaires ou technologiques." },
        { h: "Immobilier et allocation d'actifs", p: "Tout investissement, y compris immobilier, presente des risques inherents aux fluctuations de marche, aux evolutions reglementaires et aux conditions economiques locales et internationales. Les performances passees ne garantissent pas les performances futures." },
        { h: "Absence de conseil personnalise", p: "Les informations presentes sur ce site ne sauraient se substituer a un conseil individualise tenant compte de votre situation personnelle, patrimoniale et fiscale specifique. Nous vous recommandons de consulter un conseiller qualifie avant toute decision d'investissement." },
        { h: "Responsabilite", p: "Janus Capital Strategy ne pourra etre tenu responsable des consequences directes ou indirectes decoulant de decisions d'investissement prises sur la base des informations diffusees sur ce site." }
      ]
    },
    En: {
      metaTitle: "Risk Disclosure | Janus Capital Strategy",
      metaDesc: "Risk disclosure related to digital assets and investments offered by Janus Capital Strategy.",
      title: "Risk Disclosure",
      intro: "The content published on this website is provided for informational purposes only and does not constitute legal advice, tax advice, or a personalized investment solicitation.",
      sections: [
        { h: "Digital Assets", p: "Digital assets, including Bitcoin and other cryptoassets, carry a risk of capital loss, potentially up to the total loss of invested capital. Their value may experience significant volatility due to market, regulatory, or technological factors." },
        { h: "Real Estate and Asset Allocation", p: "Any investment, including real estate, carries risks inherent to market fluctuations, regulatory changes, and local and international economic conditions. Past performance does not guarantee future results." },
        { h: "No Personalized Advice", p: "The information provided on this website cannot replace individualized advice that accounts for your specific personal, wealth, and tax situation. We recommend consulting a qualified advisor before making any investment decision." },
        { h: "Liability", p: "Janus Capital Strategy cannot be held liable for direct or indirect consequences arising from investment decisions made based on the information published on this website." }
      ]
    },
    Ar: {
      metaTitle: "الإفشاء عن المخاطر | جانوس كابيتال ستراتيجي",
      metaDesc: "الإفشاء عن المخاطر المتعلقة بالأصول الرقمية والاستثمارات التي تقدمها جانوس كابيتال ستراتيجي.",
      title: "الإفشاء عن المخاطر",
      intro: "المحتويات المنشورة على هذا الموقع مقدمة لأغراض إعلامية فقط ولا تشكل مشورة قانونية أو ضريبية أو عرضاً استثمارياً موجهاً بشكل فردي.",
      sections: [
        { h: "الأصول الرقمية", p: "تحمل الأصول الرقمية، بما فيها البيتكوين وغيرها من الأصول المشفرة، خطر فقدان رأس المال، وقد يصل ذلك إلى فقدان كامل لرأس المال المستثمر. قد تشهد قيمتها تقلبات كبيرة بسبب عوامل السوق أو التنظيمية أو التقنية." },
        { h: "العقارات وتخصيص الأصول", p: "يحمل أي استثمار، بما في ذلك العقارات، مخاطر ملازمة لتقلبات السوق والتغييرات التنظيمية والأوضاع الاقتصادية المحلية والدولية. الأداء السابق لا يضمن النتائج المستقبلية." },
        { h: "غياب المشورة الفردية", p: "لا يمكن للمعلومات الواردة في هذا الموقع أن تحل محل مشورة فردية تأخذ في الاعتبار وضعكم الشخصي والثروي والضريبي المحدد. نوصي بالتشاور مع مستشار مؤهل قبل اتخاذ أي قرار استثماري." },
        { h: "المسؤولية", p: "لا يمكن تحميل جانوس كابيتال ستراتيجي المسؤولية عن أي نتائج مباشرة أو غير مباشرة ناتجة عن قرارات استثمارية اتخذت بناءً على المعلومات المنشورة في هذا الموقع." }
      ]
    }
  };

  const t = translations[lang] || translations.En;
  const isRtl = false;

  return (
    <div className="janus-page min-h-screen font-sans" dir={isRtl ? 'rtl' : 'ltr'}>
      <Helmet>
        <title>{t.metaTitle}</title>
        <meta name="description" content={t.metaDesc} />
      </Helmet>
      <section className="pt-40 pb-24 px-6 lg:px-12 max-w-[900px] mx-auto">
        <h1 className="text-3xl md:text-4xl font-light tracking-wide mb-10 janus-title uppercase">{t.title}</h1>
        <div className="space-y-6 janus-text-muted font-light leading-relaxed text-justify">
          <p>{t.intro}</p>
          {t.sections.map((s, i) => (
            <p key={i}><strong>{s.h}</strong><br/>{s.p}</p>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
